import { useRef, useState, useEffect } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { ToastContainer } from "react-toastify";
import CloseIcon from '@material-ui/icons/Close';
import moment from "moment";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Select from 'react-select';
import jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable'
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

import { getTrans as t } from "../../Localization/translations";
import authHeader from "../../services/auth-header";
import { API } from "../../backend";
import Helper from "../../Helper";
import subcompanyService from "../../services/company/subcompanyService";
import lineOfBusinessService from "../../services/company/lineofbusinessService";

function TrialBalance({ id, contract_type, setSelectedTab, setTransaction, initialAccountCode }) {
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const tableRef = useRef();
  const DR_CR = {
    D: "Debit",
    C: "Credit",
  };
  let period_year = "";
  let calendar_name = "";
  const location = useLocation();
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputvalue, setValue] = useState("");
  const [selectedValue2, setSelectedValue2] = useState(null);
  const [selectedValue3, setSelectedValue3] = useState("");
  const [selectedValueenddate, setSelectedValueEndate] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);
  const [isLoading2, setIsLoading2] = useState(false);

  const [subcompany, setSubcompany] = useState("");
  const [lineOfBusiness, setLineOfBusiness] = useState("");
  const [subcompanyOptions, setSubcompanyOptions] = useState([]);
  const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);

  const [accountCode, setAccountCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");

  // const [accountValue, setAccountValue] = useState(null);
  const [accountOptions, setAccountOptions] = useState([]);
  const [accountInputValue, setAccountInputValue] = useState("");
  const [accountPage, setAccountPage] = useState(1);
  const [accountLoading, setAccountLoading] = useState(false);

  const [accountValue, setAccountValue] = useState(
    initialAccountCode
      ? { account_number: initialAccountCode, label: initialAccountCode }
      : null
  );

  const [summaryData, setSummaryData] = useState([]);
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);




  useEffect(() => {
    if (location.state?.startDate && location.state?.endDate) {
      setSelectedValue3(location.state.startDate);
      setSelectedValueEndate(location.state.endDate);
    }
  }, [location.state]);


  const fetchSubcompanies = () => {
    try {
      subcompanyService.getSubcompany().then((response) => {
        const companies = response.data || [];

        setSubcompanyOptions(companies);

      });
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch Lines of Business
  const fetchLinesOfBusiness = () => {
    try {
      lineOfBusinessService.getLineOfBusiness().then((response) => {
        const lobs = response.data || [];
        setLineOfBusinessOptions(lobs);
        setLineOfBusinessOptions(lobs);

      });
    } catch (err) {

      console.error(err);
    }
  };

  const loadAccountOptions = async (value, page) => {
    try {
      if (!value) return;

      setAccountLoading(true);

      const response = await fetch(
        `${API}accounting/accounts/?search=${value}&per_page=10&page=${page}`,
        { headers: authHeader() }
      );

      const result = await response.json();

      if (result?.data?.length > 0) {
        setAccountOptions((prev) => [...prev, ...result.data]);
        setAccountPage((prev) => prev + 1);
      }

      setAccountLoading(false);
    } catch (error) {
      console.error("Account load error:", error);
      setAccountLoading(false);
    }
  };




  const handleAccountInputChange = (value, action) => {
    if (action.action === "input-change") {
      setAccountInputValue(value);
      setAccountPage(1);
      setAccountOptions([]);
      loadAccountOptions(value, 1);
    }
  };

  const handleAccountScrollBottom = () => {
    loadAccountOptions(accountInputValue, accountPage);
  };

  const handleAccountChange = (value) => {
    setAccountValue(value);
  };



  useEffect(() => {
    fetchSubcompanies();
    fetchLinesOfBusiness();
  }, []);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const range = {
    "Today": [moment(), moment()],
    "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment()
        .subtract(1, "month")
        .startOf("month"),
      moment()
        .subtract(1, "month")
        .endOf("month")
    ],
    "Last Year": [
      moment()
        .subtract(1, "year")
        .startOf("year"),
      moment()
        .subtract(1, "year")
        .endOf("year")
    ]
  };

  const handleEvent = (event, picker) => {
    setFromDate(picker.startDate);
    setToDate(picker.endDate);
  };

  const handleEvent2 = (event, picker) => {
    setSelectedValue3(picker.startDate);
    setSelectedValueEndate(picker.endDate);
  };

  const handleClear = () => {
    setSelectedValue(null);
    setSelectedValue2(null);
    setSelectedValue3('');
    setSelectedValueEndate('')
    setFromDate('')
    setToDate('')
    setSelectedValueType(null)
    setSubcompany("");
    setLineOfBusiness("");
    setAccountValue(null);
    setAccountOptions([]);
    setAccountInputValue("");
    tableRef.current.onQueryChange();
  };


  const fetchSummary = () => {

    let url = API + "accounting/glentrysummary/?";

    url += `&contract_number=${id || ""}`;
    url += `&subcompany=${subcompany || ""}`;
    url += `&line_of_business=${lineOfBusiness || ""}`;

    if (accountValue) {
      url += `&account_code=${accountValue.account_number}`;
    }

    fetch(url, { headers: authHeader() })
      .then(res => res.json())
      .then(data => {
        setSummaryData(data);
      });
  };


  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 10;

    while (true) {
      const query = {
        pageSize,
        page: currentPage,
        search: '',
      };

      let customerName = "";
      let transactionType = ""
      if (selectedValue) {
        customerName = selectedValue.id;
      }
      if (selectedValueType) {
        transactionType = selectedValueType.transaction_type
      }
      const url =
        API +
        "accounting/glenteryview/?" +
        "per_page=" +
        query.pageSize +
        "&search=" + query.search +
        "&page=" + (query.page + 1) +
        "&contract_number=" +
        (id !== undefined && id !== '' ? id : (customerName !== undefined ? customerName : '')) +
        "&period_name=" +
        (period_year !== "" ? period_year : "") +
        "&start_date=" +
        (selectedValue3 !== "" ? Helper.DatePicker(selectedValue3) : "") +
        "&end_date=" +
        "" +
        "&transactionend_date=" +
        (selectedValueenddate !== ""
          ? Helper.DatePicker(selectedValueenddate)
          : "") +
        "&creation_startdate=" +
        (fromDate !== "" ? Helper.DatePicker(fromDate) : "") +
        "&creation_enddate=" +
        (toDate !== "" ? Helper.DatePicker(toDate) : "") +
        "&transaction_type=" +
        (transactionType !== "" ? transactionType : "")

      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();
        if (result.data.length === 0) {
          break;
        }

        allData = allData.concat(result.data);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }

    return allData;
  };

  const handleInputChangeData = (value) => {
    setValue(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptionsData(value, 1);
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputvalue, currentPage2);
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading2(true);
        const response = await fetch(`${API}contracts/contracts/filter/?id=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading2(false);
    }
  };

  const handelChange = (value1) => {
    setSelectedValue(value1);
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
      if (columnDef.field === 'amount') {
        alignmentStyles[index] = { halign: 'right' };
      } else {
        alignmentStyles[index] = { halign: 'left' };
      }
    });
    return alignmentStyles;
  }
  const [transactionValue, setTransactionValue] = useState('')
  const [currentPage3, setcurrentPage3] = useState(1)
  const [options3, setOptions3] = useState([]);
  const [selectedValueType, setSelectedValueType] = useState(null);
  const [isLoading3, setIsLoading3] = useState(false);

  const handelInputChange = (value) => {
    setTransactionValue(value);
    setcurrentPage3(1);
    setOptions3([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(transactionValue, currentPage3);
  };

  const handelChangeTransaction = (value) => {
    setSelectedValueType(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading3(true);
        const response = await fetch(`${API}accounting/transactiontypes/filter/?transaction_types=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions3((prevOptions) => [...prevOptions, ...newOptions]);
          setcurrentPage3((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading3(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading3(false);
    }
  };

  const clearDates = () => {
    setSelectedValue3('');
    setSelectedValueEndate('')
  };

  const createtionClearDates = () => {
    setFromDate('')
    setToDate('')
  }

  const handleinvoiceView = (id) => {
    // navigate("/billing/viewinvoices", { state: id })
    setTransaction(id)
    setSelectedTab(7)
  }


  return (
    <div className="" style={{ position: "relative", minHeight: "171vh" }}>
      <div className="row py-2 mt-2" style={{ marginBottom: "50px" }}>
        <ToastContainer />
        <div className=""
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            overflow: "auto",
          }}>
          <div className=" mb-0">
            <div className="header pb-0">
              <div className="">
                <div>
                  {/* <h5 className="mb-0 tc">{t("Transactions")}</h5> */}
                </div>
              </div>
            </div>
            <div className="">
              <div className="p-0">
                {/* {
                    contract_type === "Lease"? */}

                <MaterialTable
                  tableRef={tableRef}
                  style={{
                    padding: "0.5rem 0.5rem",
                    backgroundColor: "var(--bs-table-bg)",
                    borderBottomWidth: "1px",
                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                    overflowX: 'auto',
                  }}
                  // title={<h5 className="mb-0">{t("Accounting Entries")}</h5>}
                  title={
                    <h5>
                      {t("Accounting Entries")}
                      <Typography
                        variant="body2"
                        style={{
                          color: "#245C7F",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() => {
                          fetchSummary();
                          setIsSummaryOpen(true);
                        }}
                      >
                        {t("Summary")}
                      </Typography>
                    </h5>
                  }
                  columns={[

                    {
                      title: `${t("Transaction")}`,
                      field: "transaction",
                      defaultSort: "desc", // Set default sorting direction
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction")}</div>
                          <div className="hyperlink" onClick={() => handleinvoiceView(rowData.transaction)}>{(rowData.transaction_header)}</div>
                        </>
                      ),
                      headerStyle: {
                        width: "120px",
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        width: "120px",
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Transaction Type")}`,
                      field: "transaction_type",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Type")}</div>
                          <div>{(rowData.transaction_type)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Transaction Date")}`,
                      field: "transaction_date",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Date")}</div>
                          <div>{(rowData.transaction_date ? Helper.DateNormal(rowData.transaction_date) : 'none')}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Creation Date")}`,
                      field: "creation_date",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Creation Date")}</div>
                          <div>{(rowData.creation_date ? Helper.DateNormal(rowData.creation_date) : 'none')}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Sub Company")}`,
                      field: "subcompany_name",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {" "}
                            {t("Sub Company")}
                          </div>
                          <div>{rowData.subcompany_name}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Contract Number")}`,
                      field: "contract_number",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Contract Number")}
                          </div>
                          <div>{rowData.contract_number || "-"}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Customer Name")}`,
                      field: "customer_name",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Customer Name")}
                          </div>
                          <div>{rowData.customer_name || "-"}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Product")}`,
                      field: "product",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Product")}
                          </div>
                          <div>{rowData.product || "-"}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Line of Business")}`,
                      field: "line_of_business_name",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {" "}
                            {t("Line of Business")}
                          </div>
                          <div>{rowData.line_of_business_name}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Transaction Line")}`,
                      field: "transaction_line",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Line")}</div>
                          <div>{(rowData.line_number)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Line Type")}`,
                      field: "transaction_line_type",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Line Type")}</div>
                          <div>{rowData.transaction_line_type}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      // title: `${t("Account Code")}`,
                      title: `${t("Account Number")}`,
                      // field: "account",
                      field: "accounts_code",
                      render: (rowData) => (
                        <>
                          {/* <div className="d-xl-none tc d-md-none d-lg-none">{t("Account Code")}</div> */}
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Account Number")}</div>
                          {/* <div>{(rowData.account)}</div> */}
                          <div>{rowData.accounts_code ? (rowData.accounts_code) : ""}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Account Name")}`,
                      // field: "account_name",
                      field: "accounts_name",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Account name")}</div>
                          <div>{rowData.accounts_name ? (rowData.accounts_name) : ""}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("DR/CR")}`,
                      field: 'dr_cr_indicator',
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("DR/CR")}</div>
                          <div>{DR_CR[rowData.dr_cr_indicator]}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Amount")}`,
                      field: "amount",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Amount")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                          {Helper.Amount(rowData.amount)}
                        </div></>
                      ,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Exported")}`,
                      field: "exported_flag",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Exported")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                          {(rowData.exported_flag)}
                        </div></>
                      ,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },

                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      const { orderBy, orderDirection } = query;
                      let transactionValue = '';
                      let subcompanyParam = subcompany || "";
                      let lineOfBusinessParam = lineOfBusiness || "";

                      if (selectedValue2 && selectedValue) {
                        calendar_name = selectedValue.id;
                        period_year = selectedValue2.period_name;
                      } else if (selectedValue) {
                        calendar_name = selectedValue.id;
                      } else if (selectedValue2) {
                        period_year = selectedValue2.period_name;
                      } else if (selectedValueType) {
                        transactionValue = selectedValueType.transaction_type
                        if (id !== undefined) {
                          calendar_name = id
                        }
                      }
                      else {
                        if (id !== undefined) {

                          calendar_name = id
                        }
                        else {
                          calendar_name = ""
                        }
                      }
                      let url = API + "accounting/glenteryview/?";
                      url += "per_page=" + query.pageSize;
                      url += "&page=" + (query.page + 1);
                      url += "&search=" + query.search;

                      url += `&contract_number=${calendar_name !== "" ? calendar_name : ""
                        }`;
                      url += `&period_name=${period_year !== "" ? period_year : ""
                        }`;
                      url += `&start_date=${selectedValue3 !== "" ? Helper.DatePicker(selectedValue3) : ""
                        }`;
                      url += `&end_date=${""
                        }`;
                      url += `&transactionend_date=${selectedValueenddate !== "" ? Helper.DatePicker(selectedValueenddate) : ""
                        }`;
                      url += `&creation_startdate=${fromDate !== "" ? Helper.DatePicker(fromDate) : ""
                        }`;
                      url += `&creation_enddate=${toDate !== "" ? Helper.DatePicker(toDate) : ""
                        }`;
                      url += `&transaction_type=${transactionValue !== "" ? transactionValue : ""
                        }`;
                      url += `&subcompany=${subcompanyParam}`;
                      url += `&line_of_business=${lineOfBusinessParam}`;

                      // url += `&account_code=${accountCodeValue ? accountCodeValue.account_code : ""}`;
                      // url += `&account_number=${accountNumberValue ? accountNumberValue.account_number : ""}`;
                      url += `&account_code=${accountValue ? accountValue.account_number : ""}`;






                      if (orderBy) {
                        url += `&orderBy=${orderBy.field}`;
                        url += `&orderDirection=${orderDirection}`;
                      }
                      fetch(url, { headers: authHeader() })
                        .then((response) => response.json())
                        .then((result) => {

                          setSummaryData(result.summary || []);

                          resolve({
                            data:
                              query.orderBy && query.orderDirection
                                ? _.orderBy(
                                  result.data.reverse().map((item, idx, array) => {
                                    const sameIdItems = array.filter((record) => record.id === item.id);
                                    const serial = sameIdItems.findIndex((record) => record === item) + 1;
                                    return { ...item, serial };
                                  }),
                                  [query.orderBy.field],
                                  [query.orderDirection]
                                )
                                : result.data.reverse().map((item, idx, array) => {
                                  const sameIdItems = array.filter((record) => record.id === item.id);
                                  const serial = sameIdItems.findIndex((record) => record === item) + 1;
                                  return { ...item, serial };
                                }),
                            page: result.page - 1,
                            totalCount: result.total,
                          });
                        });
                    })
                  }

                  components={{
                    Toolbar: (props) => (
                      <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class" style={{ overflowX: 'auto' }}>
                        <MTableToolbar {...props} />
                        {id === undefined &&
                          <span
                            onClick={() => setState({ isPaneOpen: true })}
                            style={{
                              color: "#b4b7c5",
                              paddingRight: "10px",
                              cursor: "pointer",
                            }}
                          >
                            {/* <i class="fa fa-light fa-filter"></i> */}
                            <img
                              alt=""
                              src={
                                process.env.PUBLIC_URL +
                                "/static/images/ic-filter.svg"
                              }
                            />
                          </span>
                        }
                      </div>
                    ),
                  }}
                  options={{
                    headerStyle: {
                      backgroundColor: "white",
                      color: "#245C7F",
                      fontSize: 12,
                    },
                    rowStyle: (rowData, index) => {
                      if (index % 2) {
                        return { backgroundColor: "#fff" };
                      }
                    },
                    sorting: true,
                    search: true,
                    toolbar: true,
                    paging: true,
                    pageSize: 10,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [10, 15, 20, 50],
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    exportAllData: true,
                    exportButton: true,
                    exportFileName: "Trial Balance",
                    exportCsv: async (columns, data) => {
                      const allData = await fetchAllDataForExport(); // Fetch all data
                      const csvColumns = Helper.visibleColumn(columns);
                      const csvColumnTitles = csvColumns.map(column => column.title);
                      const title = "Accounting Entries Report";
                      let csvContentWithInfo = `${title}\n`;
                      if (selectedValue !== null) {
                        var selectedVal = selectedValue.contract_number
                        csvContentWithInfo += `Fiter By Contract Number : ${selectedVal}\n`;
                      }
                      if (selectedValue3 !== '' && selectedValueenddate !== '') {
                        var selectedVal3 = selectedValue3
                        var selectedValueEnddate = selectedValueenddate
                        csvContentWithInfo += `Fiter By Transaction Date : ${Helper.DateNormal(selectedVal3)} to ${Helper.DateNormal(selectedValueEnddate)}\n`

                      }
                      if (fromDate !== '' && toDate !== '') {
                        var fromDates = fromDate
                        var toDates = toDate
                        csvContentWithInfo += `Fiter By Creation Date : ${Helper.DateNormal(fromDates)} to ${Helper.DateNormal(toDates)}\n`

                      }
                      if (selectedValueType !== null) {
                        var transaction_type = selectedValueType.transaction_type
                        csvContentWithInfo += `Fiter By Transaction Type : ${transaction_type}\n`

                      }
                      const currentDate = new Date().toLocaleDateString();
                      csvContentWithInfo += `Date: ${currentDate}\n\n`;
                      const csvData = allData.map(rowData => {
                        const rowDataArray = csvColumns.map(columnDef => {
                          if (columnDef.field === "transaction_id.transaction_number") {
                            return rowData.transaction_id ? Helper.DateNormal(rowData.transaction_id.transaction_number) : "";
                          } else if (columnDef.field === "contract_id.contract_number") {
                            return rowData.contract_id ? rowData.contract_id.contract_number : "";
                          } else if (columnDef.field === "d_c_code") {
                            return rowData.d_c_code ? DR_CR[rowData.d_c_code] : "";
                          }
                          else if (columnDef.field === "contract_number") {
                            return rowData.contract_number || "";
                          }
                          else if (columnDef.field === "customer_name") {
                            return rowData.customer_name || "";
                          }
                          else if (columnDef.field === "product") {
                            return rowData.product || "";
                          }
                          else if (columnDef.field === "amount") {
                            return rowData.amount ? Helper.Amount(rowData.amount) : "";
                          } else if (columnDef.field === "transaction_id.creation_date") {
                            return rowData.transaction_id.creation_date ? Helper.DateNormal(rowData.transaction_id.creation_date) : "";
                          } else if (columnDef.field === "transaction_id.transaction_date") {
                            return rowData.transaction_id ? Helper.DateNormal(rowData.transaction_id.transaction_date) : "";

                          } else {
                            return rowData[columnDef.field];
                          }
                        });
                        return rowDataArray;
                      });

                      const csvRows = [csvColumnTitles, ...csvData];
                      const csvContent = `${csvContentWithInfo}${csvRows.map(row => {
                        return row.map(field => {
                          if (field === null || field === undefined) {
                            return '""';
                          }
                          const fieldStr = String(field);
                          if (fieldStr.includes(',')) {
                            return `"${fieldStr}"`;
                          } else {
                            return fieldStr;
                          }
                        }).join(',');
                      }).join('\n')}`;
                      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                      const link = document.createElement('a');
                      link.href = URL.createObjectURL(blob);
                      link.download = 'Accounting Entries.csv';
                      link.style.display = 'none';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    },
                    exportPdf: async (columns, data) => {
                      const allData = await fetchAllDataForExport(); // Fetch all data
                      if (allData.length === 0) {
                        console.error("No data found for PDF export");
                        return;
                      }
                      const visibleColumns = Helper.visibleColumn(columns);
                      const doc = new jsPDF();
                      doc.setFont("helvetica", "bold");
                      doc.setFontSize(16);

                      const title = "Accounting Entries Report";
                      doc.text(title, 14, 10);

                      doc.setFontSize(12);
                      doc.setFont("helvetica", "normal");
                      const currentDate = new Date().toLocaleDateString();
                      doc.text(`Date : ${currentDate}`, 14, 15);

                      const space = 25;
                      const tableStartY = 5 + space;
                      if (selectedValue !== null) {
                        const selectedVal = selectedValue?.contract_number;
                        doc.text(`Filter By Contract Number : ${selectedVal === 'undefined' ? "" : selectedVal}`, 14, 20);
                      }
                      if (selectedValueType !== null) {
                        const transaction_type = selectedValueType.transaction_type;
                        doc.text(`Filter By Transaction Type : ${transaction_type === 'undefined' ? "" : transaction_type}`, 14, 20);
                      }
                      if (selectedValue3 !== '' && selectedValueenddate !== '') {
                        const selectedValueS3 = Helper.DateNormal(selectedValue3);
                        const selectedValueed = Helper.DateNormal(selectedValueenddate);
                        doc.text(`Filter By Transaction Date : ${selectedValueS3 === 'undefined' ? '' : selectedValueS3} to ${selectedValueed === 'undefined' ? '' : selectedValueed}`, 14, 25);
                      }
                      if (fromDate !== '' && toDate !== '') {
                        const fromDates = Helper.DateNormal(fromDate)
                        const toDates = Helper.DateNormal(toDate)
                        doc.text(`Filter By Creation Date : ${fromDates === 'undefined' ? '' : fromDates} to ${toDates === 'undefined' ? '' : toDates}`, 14, 28);
                      }
                      const columnTitles = visibleColumns.map(columnDef => columnDef.title);
                      const pdfData = allData.map(rowData => {
                        const rowDataArray = visibleColumns.map(columnDef => {
                          if (columnDef.field === "transaction_id.transaction_number") {
                            return rowData.transaction_id ? Helper.DateNormal(rowData.transaction_id.transaction_number) : "";
                          } else if (columnDef.field === "contract_id.contract_number") {
                            return rowData.contract_id ? rowData.contract_id.contract_number : "";
                          } else if (columnDef.field === "amount") {
                            return rowData.amount ? Helper.Amount(rowData.amount) : "";
                          }
                          else if (columnDef.field === "d_c_code") {
                            return rowData.d_c_code ? DR_CR[rowData.d_c_code] : "";
                          } else if (columnDef.field === "transaction_id.creation_date") {
                            return rowData.transaction_id.creation_date ? Helper.DateNormal(rowData.transaction_id.creation_date) : "";
                          } else if (columnDef.field === "transaction_id.transaction_date") {
                            return rowData.transaction_id ? Helper.DateNormal(rowData.transaction_id.transaction_date) : "";
                          }
                          else if (columnDef.field === "contract_number") {
                            return rowData.contract_number || "";
                          }
                          else if (columnDef.field === "customer_name") {
                            return rowData.customer_name || "";
                          }
                          else if (columnDef.field === "product") {
                            return rowData.product || "";
                          }
                          else {
                            return rowData[columnDef.field];
                          }
                        });
                        return rowDataArray;
                      });
                      // doc.autoTable({
                      autoTable(doc, {
                        head: [columnTitles],
                        body: pdfData,
                        startY: tableStartY,
                        columnStyles: getAlignmentStyles(visibleColumns),
                      });

                      doc.save(`Accounting Entries.pdf`);
                    },
                    actionsColumnIndex: -1,
                    columnsButton: true,
                  }}
                />

                <Dialog
                  open={isSummaryOpen}
                  onClose={() => setIsSummaryOpen(false)}
                  PaperProps={{
                    style: {
                      width: "600px",
                      maxWidth: "90%",
                      borderRadius: "8px",
                    },
                  }}
                >
                  <DialogTitle
                    style={{
                      fontWeight: "bold",
                      color: "#1E88E5",
                      borderBottom: "1px solid #E0E0E0",
                      paddingBottom: "10px",
                    }}
                  >
                    Trial Balance Summary
                  </DialogTitle>

                  <DialogContent>
                    <div style={{ overflowX: "auto" }}>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginTop: "10px",
                        }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                textAlign: "left",
                                padding: "10px",
                                backgroundColor: "#E3F2FD",
                                color: "#1565C0",
                                fontWeight: "bold",
                                borderBottom: "2px solid #B0BEC5",
                              }}
                            >
                              Account Name
                            </th>

                            <th
                              style={{
                                textAlign: "right",
                                padding: "10px",
                                backgroundColor: "#E3F2FD",
                                color: "#1565C0",
                                fontWeight: "bold",
                                borderBottom: "2px solid #B0BEC5",
                              }}
                            >
                              Total
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {summaryData.length > 0 ? (
                            summaryData.map((row, index) => (
                              <tr
                                key={index}
                                style={{
                                  borderBottom: "1px solid #F5F5F5",
                                }}
                              >
                                <td
                                  style={{
                                    padding: "10px",
                                    color: "#424242",
                                    fontWeight: 500,
                                  }}
                                >
                                  {row.account_name}
                                </td>

                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "right",
                                    fontWeight: 500,
                                    color: row.total >= 0 ? "#424242" : "#424242", 
                                  }}
                                >
                                  {Helper.Amount(row.total)}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="2"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  color: "#9E9E9E",
                                }}
                              >
                                No summary data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </DialogContent>

                  <DialogActions>
                    <Button
                      onClick={() => setIsSummaryOpen(false)}
                      color="primary"
                      style={{
                        textTransform: "none",
                        fontWeight: "bold",
                        color: "#1E88E5",
                      }}
                    >
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* : */}
                {/* <MaterialTable
                    tableRef={tableRef}
                    style={{
                      padding: "0.5rem 0.5rem",
                      backgroundColor: "var(--bs-table-bg)",
                      borderBottomWidth: "1px",
                      boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                    }}
                    title={<h5 className="mb-0">{t("Accounting Entries")}</h5>}
                    columns={[
                      {
                        title: `${t("Transaction Type")}`,
                        field: "transaction_type_id",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Type")}</div>
                            <div>{rowData.transaction_type_id}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Transaction Date")}`,
                        field: "transaction_id.transaction_date",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Date")}</div>
                            <div>{Helper.DateNormal(rowData.transaction_id.transaction_date)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Transaction Number")}`,
                        field: "transaction_id.transaction_number",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Number")}</div>
                            <div>{rowData.transaction_id.transaction_number}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Contract Number")}`,
                        field: "contract_id.contract_number",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("Contract Number")}</div>
                            <div>{rowData.contract_id.contract_number}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Account Code")}`,
                        field: "account_code",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("Account Code")}</div>
                            <div>{(rowData.account_code)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Account Number")}`,
                        field: "account_number",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("Account Number")}</div>
                            <div>{(rowData.account_number)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("DR/CR")}`,
                        field: 'd_c_code',
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("DR/CR")}</div>
                            <div>{DR_CR[rowData.d_c_code]}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Amount")}`,
                        field: "amount",
                        render: (rowData) => <>
                          <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                          >{t("Amount")}</div>
                          <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                            {Helper.Amount(rowData.amount)}
                          </div></>
                        ,
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Creation Date")}`,
                        field: "transaction_id.creation_date",
                        render: (rowData) =>
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("Creation Date")}</div>
                            <div>{Helper.DateNormal(rowData.transaction_id.creation_date)}
                            </div></>,
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                    ]}
                    data={(query) =>
                      new Promise((resolve, reject) => {
                        const { orderBy, orderDirection } = query;
                        let transactionValue = '';

                        if (selectedValue2 && selectedValue) {
                          calendar_name = selectedValue.id;
                          period_year = selectedValue2.period_name;
                        } else if (selectedValue) {
                          calendar_name = selectedValue.id;
                        } else if (selectedValue2) {
                          period_year = selectedValue2.period_name;
                        } else if (selectedValueType) {
                          transactionValue = selectedValueType.transaction_type
                          if (id !== undefined) {
                            calendar_name = id
                          }
                        }
                        else {
                          if (id !== undefined) {

                            calendar_name = id
                          }
                          else {
                            calendar_name = ""
                          }
                        }
                        let url = API + "accounting/glenteriesview/?";
                        url += "per_page=" + query.pageSize;
                        url += "&page=" + (query.page + 1);
                        url += "&search=" + query.search;

                        url += `&contract_number=${calendar_name !== "" ? calendar_name : ""
                          }`;
                        url += `&period_name=${period_year !== "" ? period_year : ""
                          }`;
                        url += `&start_date=${selectedValue3 !== "" ? Helper.DatePicker(selectedValue3) : ""
                          }`;
                        url += `&end_date=${""
                          }`;
                        url += `&transactionend_date=${selectedValueenddate !== "" ? Helper.DatePicker(selectedValueenddate) : ""
                          }`;
                        url += `&creation_startdate=${fromDate !== "" ? Helper.DatePicker(fromDate) : ""
                          }`;
                        url += `&creation_enddate=${toDate !== "" ? Helper.DatePicker(toDate) : ""
                          }`;
                        url += `&transaction_type=${transactionValue !== "" ? transactionValue : ""
                          }`;
                        if (orderBy) {
                          url += `&orderBy=${orderBy.field}`;
                          url += `&orderDirection=${orderDirection}`;
                        }
                        fetch(url, { headers: authHeader() })
                          .then((response) => response.json())
                          .then((result) => {
                            resolve({
                              data:
                                query.orderBy && query.orderDirection
                                  ? _.orderBy(
                                    result.data.reverse(),
                                    [query.orderBy.field],
                                    [query.orderDirection]
                                  )
                                  : result.data.reverse(),
                              page: result.page - 1,
                              totalCount: result.total,
                            });
                          });
                      })
                    }

                    components={{
                      Toolbar: (props) => (
                        <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                          <MTableToolbar {...props} /> */}
                {/* {id === undefined &&  */}
                {/* <span
                            onClick={() => setState({ isPaneOpen: true })}
                            style={{
                              color: "#b4b7c5",
                              paddingRight: "10px",
                              cursor: "pointer",
                            }}
                          > */}
                {/* <i class="fa fa-light fa-filter"></i> */}
                {/* <img
                              alt=""
                              src={
                                process.env.PUBLIC_URL +
                                "/static/images/ic-filter.svg"
                              }
                            />
                          </span> */}
                {/* } */}
                {/* </div>
                      ),
                    }}
                    options={{
                      headerStyle: {
                        backgroundColor: "white",
                        color: "#245C7F",
                        fontSize: 12,
                      },
                      rowStyle: (rowData, index) => {
                        if (index % 2) {
                          return { backgroundColor: "#fff" };
                        }
                      },
                      sorting: true,
                      search: true,
                      toolbar: true,
                      paging: true,
                      pageSize: 10, // make initial page size
                      emptyRowsWhenPaging: false, // To avoid of having empty rows
                      pageSizeOptions: [10, 15, 20, 50],
                      paginationType: "stepped",
                      showFirstLastPageButtons: false,
                      exportAllData: true,
                      exportButton: true,
                      exportFileName: "Trial Balance",
                      exportCsv: async (columns, data) => {
                        const allData = await fetchAllDataForExport(); // Fetch all data
                        const csvColumns = Helper.visibleColumn(columns);
                        const csvColumnTitles = csvColumns.map(column => column.title);
                        if (selectedValue !== null) {
                          var selectedVal = selectedValue.contract_number
                        }
                        if (selectedValue3 !== null) {
                          var selectedVal3 = selectedValue3
                        }
                        if (selectedValueenddate !== null) {
                          var selectedValueEnddate = selectedValueenddate
                        }
                        if (fromDate !== null) {
                          var fromDates = fromDate
                        }
                        if (toDate !== null) {
                          var toDates = toDate
                        }
                        if (selectedValueType !== null) {
                          var transaction_type = selectedValueType.transaction_type
                        }
                        const title = "Accounting Entries Report";
                        const currentDate = new Date().toLocaleDateString();

                        const csvContentWithInfo = `${title}\n ${selectedValue !== null ? `Fiter By Contract Number : ${selectedVal}\n` : ''}
                        ${selectedValueType !== null ? `Fiter By Transaction Type : ${transaction_type}\n` : ''}
                        ${selectedValue3 && selectedValueenddate !== null ? `Fiter By Transaction Date : ${Helper.DateNormal(selectedVal3)} to ${Helper.DateNormal(selectedValueEnddate)}\n` : ''}
                        ${fromDate && toDate !== null ? `Fiter By Creation Date : ${Helper.DateNormal(fromDates)} to ${Helper.DateNormal(toDates)}\n` : ''}Date: ${currentDate}\n \n\n`;
                        const csvData = allData.map(rowData => {
                          const rowDataArray = csvColumns.map(columnDef => {
                            if (columnDef.field === "transaction_id.transaction_number") {
                              return rowData.transaction_id ? Helper.DateNormal(rowData.transaction_id.transaction_number) : "";
                            } else if (columnDef.field === "contract_id.contract_number") {
                              return rowData.contract_id ? rowData.contract_id.contract_number : "";
                            } else if (columnDef.field === "d_c_code") {
                              return rowData.d_c_code ? DR_CR[rowData.d_c_code] : "";
                            }
                            else if (columnDef.field === "amount") {
                              return rowData.amount ? Helper.Amount(rowData.amount) : "";
                            } else if (columnDef.field === "transaction_id.creation_date") {
                              return rowData.transaction_id.creation_date ? Helper.DateNormal(rowData.transaction_id.creation_date) : "";
                            } else if (columnDef.field === "transaction_id.transaction_date") {
                              return rowData.transaction_id ? Helper.DateNormal(rowData.transaction_id.transaction_date) : "";

                            } else {
                              return rowData[columnDef.field];
                            }
                          });
                          return rowDataArray;
                        });

                        const csvRows = [csvColumnTitles, ...csvData];
                        const csvContent = `${csvContentWithInfo}${csvRows.map(row => {
                          return row.map(field => {
                            if (field === null || field === undefined) {
                              return '""'; // Represent null values as an empty string in double quotes
                            }
                            if (field.includes(',')) {
                              return `"${field}"`;
                            } else {
                              return field;
                            }
                          }).join(',');
                        }).join('\n')}`;
                        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = 'Accounting Entries.csv';
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      },
                      exportPdf: async (columns, data) => {
                        const allData = await fetchAllDataForExport(); // Fetch all data
                        if (allData.length === 0) {
                          console.error("No data found for PDF export");
                          return;
                        }
                        const visibleColumns = Helper.visibleColumn(columns);
                        const doc = new jsPDF();
                        doc.setFont("helvetica", "bold");
                        doc.setFontSize(16);

                        const title = "Accounting Entries Report";
                        doc.text(title, 14, 10);

                        doc.setFontSize(12);
                        doc.setFont("helvetica", "normal");
                        const currentDate = new Date().toLocaleDateString();
                        doc.text(`Date : ${currentDate}`, 14, 15);

                        const space = 25; // Adjust the space value as needed
                        const tableStartY = 5 + space;
                        if (selectedValue !== null) {
                          const selectedVal = selectedValue?.contract_number;
                          doc.text(`Filter By Contract Number : ${selectedVal === 'undefined' ? "" : selectedVal}`, 14, 20);
                        }
                        if (selectedValueType !== null) {
                          const transaction_type = selectedValueType.transaction_type;
                          doc.text(`Filter By Transaction Type : ${transaction_type === 'undefined' ? "" : transaction_type}`, 14, 20);
                        }
                        if (selectedValue3 !== '' && selectedValueenddate !== '') {
                          const selectedValueS3 = Helper.DateNormal(selectedValue3);
                          const selectedValueed = Helper.DateNormal(selectedValueenddate);
                          doc.text(`Filter By Transaction Date : ${selectedValueS3 === 'undefined' ? '' : selectedValueS3} to ${selectedValueed === 'undefined' ? '' : selectedValueed}`, 14, 25);
                        }
                        if (fromDate !== '' && toDate !== '') {
                          const fromDates = Helper.DateNormal(fromDate)
                          const toDates = Helper.DateNormal(toDate)
                          doc.text(`Filter By Creation Date : ${fromDates === 'undefined' ? '' : fromDates} to ${toDates === 'undefined' ? '' : toDates}`, 14, 28);
                        }
                        const columnTitles = visibleColumns.map(columnDef => columnDef.title);
                        const pdfData = allData.map(rowData => {
                          const rowDataArray = visibleColumns.map(columnDef => {
                            if (columnDef.field === "transaction_id.transaction_number") {
                              return rowData.transaction_id ? Helper.DateNormal(rowData.transaction_id.transaction_number) : "";
                            } else if (columnDef.field === "contract_id.contract_number") {
                              return rowData.contract_id ? rowData.contract_id.contract_number : "";
                            } else if (columnDef.field === "amount") {
                              return rowData.amount ? Helper.Amount(rowData.amount) : "";
                            }
                            else if (columnDef.field === "d_c_code") {
                              return rowData.d_c_code ? DR_CR[rowData.d_c_code] : "";
                            } else if (columnDef.field === "transaction_id.creation_date") {
                              return rowData.transaction_id.creation_date ? Helper.DateNormal(rowData.transaction_id.creation_date) : "";
                            } else if (columnDef.field === "transaction_id.transaction_date") {
                              return rowData.transaction_id ? Helper.DateNormal(rowData.transaction_id.transaction_date) : "";

                            } else {
                              return rowData[columnDef.field];
                            }
                          });
                          return rowDataArray;
                        });
                        doc.autoTable({
                          head: [columnTitles],
                          body: pdfData,
                          startY: tableStartY,
                          columnStyles: getAlignmentStyles(visibleColumns) // Apply column alignment styles
                        });

                        doc.save(`Accounting Entries.pdf`);
                      },
                      actionsColumnIndex: -1,
                      columnsButton: true,
                    }}
                  /> */}
                {/* } */}
              </div>
            </div>
            <SlidingPane
              className="some-custom-class"
              overlayClassName="some-custom-overlay-class"
              isOpen={state1.isPaneOpen}
              title="Filter By"
              width="auto"

              subtitle=""
              onRequestClose={() => {
                setState({ isPaneOpen: false });
              }}
            >
              {id === undefined ?
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <label className="col-form-label">{t("Sub Company")}</label>
                      <select
                        className="form-select form-control"
                        // value={subcompany}
                        name="subcompany"
                        onChange={(e) =>
                          setSubcompany(e.target.value)
                        }
                      >
                        <option value="">Select Company</option>
                        {subcompanyOptions.map((sub) => (
                          <option key={sub.id} value={sub.id}>
                            {sub.sub_company_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-12">
                      <label className="col-form-label">{t("Line of Business")} </label>
                      <select
                        className="form-select form-control"
                        // value={lineOfBusiness}
                        name="lineOfBusiness"
                        onChange={(e) =>
                          setLineOfBusiness(e.target.value)
                        }

                      >
                        <option value="">Select Line of Business</option>
                        {lineOfBusinessOptions.map((lob) => (
                          <option key={lob.id} value={lob.id}>
                            {lob.lob_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Contract Number")}
                        </label>
                        <div className="col-lg-12">
                          <Select
                            value={selectedValue}
                            filterOption={false}
                            options={options2}
                            isClearable
                            onInputChange={handleInputChangeData}
                            getOptionLabel={(options) => options.contract_number}
                            getOptionValue={(options) => options.contract_number}
                            isLoading={isLoading2}
                            placeholder={t("Search for Contract(%for All)")}
                            onMenuScrollToBottom={handleMenuScrollToBottom}
                            onChange={handelChange} />

                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Transaction Date")}
                        </label>
                        <div className="col-lg-12 position-relative">
                          <DateRangePicker
                            initialSettings={{ ranges: range }}
                            startDate={selectedValue3 !== "" ? selectedValue3 : ""}
                            endDate={selectedValueenddate !== "" ? selectedValueenddate : ""}
                            alwaysShowCalendars={true}
                            onEvent={handleEvent2}
                          >
                            <div className="form-control d-flex justify-content-between align-items-center">
                              <span>
                                {selectedValue3 !== '' ? Helper.DateNormal(selectedValue3) : "Select Start Date"} to {selectedValueenddate !== "" ? Helper.DateNormal(selectedValueenddate) : 'Select End Date'}
                              </span>

                            </div>
                          </DateRangePicker>
                          {(selectedValue3 !== '' || selectedValueenddate !== "") && (
                            <CloseIcon onClick={clearDates} style={{ position: 'absolute', top: '50%', right: '20px', transform: 'translateY(-50%)', cursor: 'pointer', height: '20px', width: '20px', color: '#b8b5b5' }} />
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Creation Date")}
                        </label>
                        <div className="col-lg-12 position-relative">
                          <DateRangePicker
                            initialSettings={{ ranges: range }}
                            startDate={fromDate !== "" ? fromDate : ""}
                            endDate={toDate !== "" ? toDate : ""}
                            alwaysShowCalendars={true}
                            onEvent={handleEvent}
                          >
                            <div className="form-control d-flex justify-content-between align-items-center">
                              <span>
                                {fromDate !== '' ? Helper.DateNormal(fromDate) : "Select Start Date"} to {toDate !== "" ? Helper.DateNormal(toDate) : 'Select End Date'}
                              </span>
                            </div>
                          </DateRangePicker>
                          {(fromDate !== '' || toDate !== "") && (
                            <CloseIcon onClick={createtionClearDates} style={{ position: 'absolute', top: '50%', right: '20px', transform: 'translateY(-50%)', cursor: 'pointer', height: '20px', width: '20px', color: '#b8b5b5' }} />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <label className="col-form-label">{t("Account")}</label>
                      <Select
                        value={accountValue}
                        filterOption={false}   // IMPORTANT
                        options={accountOptions}
                        isClearable
                        onInputChange={handleAccountInputChange}
                        getOptionLabel={(opt) => `${opt.account_number} - ${opt.account_code}`}
                        getOptionValue={(opt) => opt.account_number}
                        isLoading={accountLoading}
                        placeholder="Search Account Number or Name"
                        onMenuScrollToBottom={handleAccountScrollBottom}
                        onChange={handleAccountChange}
                      />
                    </div>
                  </div>
                </> :
                <div className="col-xl-12">
                  <div className="form-group row">
                    <label className="col-lg-12 col-form-label">
                      {t("Transaction Type")}
                    </label>
                    <div className="col-lg-12">
                      <Select
                        value={selectedValueType}
                        filterOption={false}
                        options={options3}
                        isClearable
                        onInputChange={handelInputChange}
                        getOptionLabel={(options) => options.transaction_type}
                        getOptionValue={(options) => options.transaction_type}
                        isLoading={isLoading3}
                        placeholder={t("Search for Transactiontype(%for All)")}
                        onMenuScrollToBottom={handleMenuScrollToBottomName}
                        onChange={handelChangeTransaction}
                      />
                    </div>
                  </div>
                </div>
              }
              <div className="col-xl-12">
                <div className="form-group row">
                  <div
                    className="col-lg-12 text-left"
                    style={{ marginTop: "30px" }}
                  >
                    <button
                      type="button"
                      className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                      onClick={handleClear}
                    >
                      {t("Reset")}
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      className="filter add btn btn-primary btn-m ms-auto mb-0"
                      onClick={() => Helper.handleSearch(tableRef)}
                    >
                      {t("Apply")}
                    </button>
                    &nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </SlidingPane>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrialBalance;